// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"3371ee0b","411":"941bda02","523":"b813e1d8","817":"12881a83"}[chunkId] + ".chunk.js";
};